<template>
	<div class="summary-cls">
		<section class="check-cls">
			<el-checkbox-group v-model="checkSummary" @change="handleSummary">
				<el-checkbox label="业务分类" v-if="['relx', 'majorelstg'].includes(userInfo.brandIdentify)"></el-checkbox>
				<el-checkbox label="流程标题"></el-checkbox>
				<el-checkbox label="当前分类"></el-checkbox>
				<el-checkbox label="节点名称"></el-checkbox>
				<el-checkbox label="回答选项"></el-checkbox>
				<el-checkbox label="记录"></el-checkbox>
				<el-checkbox label="推荐话术"></el-checkbox>
				<el-checkbox label="文本内容"></el-checkbox>
			</el-checkbox-group>
		</section>
		<section class="content-cls" ref="aaa" id="copyBox">
			<p v-if="checkSummary.includes('业务分类') && ['relx', 'majorelstg'].includes(userInfo.brandIdentify)"><span></span>{{obj.businessCategories}}</p>
			<p v-if="checkSummary.includes('当前分类')"><span>当前分类：</span>{{obj.nodeNames.replace(/[,]/g, " > ")}}</p>
			<div class="cell" v-for="(item, index) in obj.child" :key="index">
				<p v-if="checkSummary.includes('流程标题')"><span>流程标题：</span>{{item.q}}</p>
				<div class="cell" v-for="(_item, _index) in item.child" :key="_index">
					<p v-if="checkSummary.includes('节点名称')"><span></span>{{_item.name}}</p>
					<p v-if="checkSummary.includes('推荐话术') && _item.isSpeak"><span></span>{{_item.speak}}</p>
					<p v-if="checkSummary.includes('文本内容') && _item.welfareText"><span></span>{{welfareTextFormat(_item.welfareText)}}</p>
					<p v-if="checkSummary.includes('回答选项') && _item.isJumpOption"><span></span>{{_item.jumpOption}}</p>
					<p v-if="checkSummary.includes('记录') && _item.recordText && !_item.isRecord"><span></span>{{_item.recordText}}</p>
					<p v-if="checkSummary.includes('记录') && _item.isRecord && _item.recordList.length > 0" v-for="(__item, __index) in _item.recordList" :key="__index"><span>{{__item.name}}：</span>{{__item.value}}</p>
				</div>
			</div>
		</section>
		<section class="btns-cls">
			<el-button v-if="row.isEnd != true" size="mini" @click.stop="$emit('emitHandleClose', 'end', row.uuid)">结束流程</el-button>
			<el-button v-copy="copyText" size="mini" type="primary">一键复制</el-button>
		</section>
	</div>
</template>

<script>
import { mapGetters } from 'vuex';
export default {
	props: ['row', 'associatedList'],
	computed: {
		...mapGetters([
			'userInfo',
		])
	},
	data() {
		return {
			checkSummary: ['流程标题', '当前分类', '节点名称', '回答选项', '记录'],
			list: [],
			copyText: '',
			obj: ''
		}
	},
	created() {
		this.getCreateSummary();
		if(['relx', 'majorelstg'].includes(this.userInfo.brandIdentify)) {
			this.checkSummary.unshift('业务分类');
		}
	},
	methods: {
		getCreateSummary() {
			console.log(this.associatedList)
			this.obj = {
				businessCategories: this.associatedList[0]?.a?.businessCategories,
				nodeNames: `${this.associatedList[0].resource.name},${this.associatedList[0].nodeNames}`,
				child: []
			};

			for(const [index, value] of this.associatedList.entries()) {
				this.obj.child.push({
					q: value.q,
					child: []
				});

				for(const [_index, _value] of value.a.themeListTem.entries()) {
					if(_value.isSummary) {
						this.obj.child[index]['child'].push({
							name: _value.name,
							isSpeak: _value.isSpeak,
							speak: _value.speak,
							welfareText: this.welfareTextFormat(_value.welfareText),
							isJumpOption: _value.isJumpOption,
							jumpOption: this.jumpOptionFormat(_value.jumpOption, _value.value),
							isRecord: _value?.isRecord,
							recordText: _value?.recordText,
							recordList: _value?.recordOption
						});
					}
				}
			}
			this.handleSummary();
		},
		handleSummary() {
			let nodeNames = `${['relx', 'majorelstg'].includes(this.userInfo.brandIdentify) ? this.obj.businessCategories + '\n' : ''}当前分类：${this.obj.nodeNames.replace(/[,]/g, " > ")}`;
			let str = '';

			for(const [index, value] of this.obj.child.entries()) {
				str = `${str}\n${this.checkSummary.includes('流程标题') ? '流程标题：' + value.q : ''}`;
				for(const [_index, _value] of value.child.entries()) {
					if(_value.isRecord) {
						let __str = '';
						for(const [__index, __value] of _value.recordList.entries()) {
							__str = `${__str + (__str ? '\n' : '')}${__value.name}：${__value.value}`;
						}
						str = `${str}\n${this.checkSummary.includes('节点名称') ? _value.name + '\n' : ''}${this.checkSummary.includes('推荐话术') && _value.isSpeak ?  _value.speak + '\n' : ''}${this.checkSummary.includes('文本内容') && _value.welfareText ? _value.welfareText + '\n' : ''}${this.checkSummary.includes('回答选项') && _value.isJumpOption ? _value.jumpOption + '\n' : ''}${__str + '\n'}`;
						
					} else {
						str = `${str}\n${this.checkSummary.includes('节点名称') ? _value.name + '\n' : ''}${this.checkSummary.includes('推荐话术') && _value.isSpeak ?  _value.speak + '\n' : ''}${this.checkSummary.includes('文本内容') && _value.welfareText ? _value.welfareText + '\n' : ''}${this.checkSummary.includes('回答选项') && _value.isJumpOption ? _value.jumpOption + '\n' : ''}${(this.checkSummary.includes('记录') && _value.recordText) ? _value.recordText + '\n' : ''}`;
					}
					
				}
			}
			this.copyText = `${nodeNames}${str}`;
			this.centerDialogVisible = true;
		},
		welfareTextFormat(str) {
			return str.replace(/<[^>]+>|&[^>]+;|\n|\t/g, '');
		},
		jumpOptionFormat(arr, nextId) {
			let str = '';
			for(const item of arr) {
				if(item.id === nextId) {
					str = item.name;
				}
			}
			return str;
		}
	}

}
</script>

<style lang="scss" scoped>
.summary-cls {
	width: 100%;
	padding: 10px;
	box-sizing: border-box;

	& > .check-cls {
		width: 100%;
		margin-bottom: 10px;
	}

	& > .content-cls {
		width: 100%;
		height: 300px;
		border-radius: 4px;
		border: 1px solid #D8D8D8;
		overflow-x: hidden;
		overflow-y: auto;
		box-sizing: border-box;

		& > p {
			font-size: 14px;
			font-weight: 400;
			color: #6C7E91;
			line-height: 24px;
			padding: 0 10px;
			box-sizing: border-box;
		}

		& span {
			font-weight: bold;
		}

		& .cell {
			width: 100%;
			font-size: 14px;
			font-weight: 400;
			color: #6C7E91;
			line-height: 24px;
			border-bottom: 1px dashed #E6E9EF;
			margin-bottom: 10px;
			padding: 10px;
			box-sizing: border-box;

			&:last-child {
				border: none;
			}
		}
	}

	& > .btns-cls {
		width: 100%;
		text-align: center;
		margin: 20px 0;
	}
}
</style>